import CtrlTipoServico from './pages/CtrlTipoServicoPage.vue'

const routes = [
  {
    path: 'ctrl-tipos-servicos',
    name: 'ctrl-tipos-servicos',
    component: CtrlTipoServico
  }
];

export default routes;